import styled from "styled-components";

export const ClientSettingsSectionContainerDefaultBox = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: 45px auto;
    align-items: center;
    column-gap: 15px;

    position: relative;

    border-radius: 5px;
    background-color: ${({ theme }) => theme.colors.background};
    padding: 0 15px;
    overflow: hidden;
`